// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import EditableField from '../../../../shared/components/editable-field';
import {FormattedMessage} from 'react-intl';
import KeyValueDropDown from './key-value-dropdown';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import LabeledFormInput from '../../../../shared/components/labeled-form-input';
import {getFieldClassName} from '../../../shared/services/claim-shared-helper';
import {translate} from '../../../../shared/services/translation-service';

const LabeledKeyValueDropDown = ({className, errorMessage, highlightClass, isEditable, isValid = true, label, selectedValue, vsrMessage, ...props}) =>
    <LabeledFormInput
        className={getFieldClassName(className, isValid, highlightClass)}
        label={label}
    >
        <EditableField
            isEditable={isEditable}
            value={selectedValue.value}
        >
            <KeyValueDropDown
                {...props}
                className={className}
                value={selectedValue.key}
            />
        </EditableField>
        {!isValid && errorMessage && isEditable &&
            <span className='error-message'>
                <FormattedMessage id={errorMessage}/>
            </span>
        }
        {vsrMessage &&
            <span className='vsr-message'>{`${vsrMessage} (${translate('SAVE_TO_VALIDATE')})`}</span>
        }
    </LabeledFormInput>;

LabeledKeyValueDropDown.displayName = 'LabeledKeyValueDropDown';
LabeledKeyValueDropDown.propTypes = {
    className: PropTypes.string.isRequired,
    errorMessage: PropTypes.string,
    highlightClass: PropTypes.string,
    includeKeyInDropDown: PropTypes.bool,
    isEditable: PropTypes.bool.isRequired,
    isValid: PropTypes.bool,
    label: PropTypes.string.isRequired,
    list: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    selectedValue: PropTypes.instanceOf(KeyValuePair).isRequired,
    showPlaceholder: PropTypes.bool,
    vsrMessage: PropTypes.string
};

export default LabeledKeyValueDropDown;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-fields/labeled-key-value-dropdown.js